import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useAuth } from '../hooks/useSupabaseAuth.jsx'
import { X, LogIn } from 'lucide-react'

const AuthPrompt = ({ onAuthModalOpen }) => {
  const { user } = useAuth()
  const [isVisible, setIsVisible] = useState(false)
  const [isDismissed, setIsDismissed] = useState(false)
  const [isAnimating, setIsAnimating] = useState(false)

  useEffect(() => {
    // Show prompt only if user is not logged in and hasn't dismissed it
    if (!user && !isDismissed) {
      // Delay showing the prompt for better UX
      const timer = setTimeout(() => {
        setIsVisible(true)
        setIsAnimating(true)
      }, 3000) // Show after 3 seconds

      return () => clearTimeout(timer)
    } else {
      setIsVisible(false)
      setIsAnimating(false)
    }
  }, [user, isDismissed])

  const handleDismiss = () => {
    setIsDismissed(true)
    setIsVisible(false)
  }

  const handleSignInClick = () => {
    onAuthModalOpen()
    setIsVisible(false)
  }

  // Don't render if user is logged in or prompt is dismissed
  if (user || !isVisible) return null

  return (
    <div className={`fixed agenttom-6 right-6 z-40 transform transition-all duration-500 ease-out ${
      isAnimating ? 'translate-y-0 opacity-100 scale-100' : 'translate-y-4 opacity-0 scale-95'
    }`}>
      <div className="bg-bg-secondary border border-border-primary/50 rounded-xl shadow-2xl p-4 max-w-xs">
        {/* Close Button */}
        <button
          onClick={handleDismiss}
          className="absolute -top-2 -right-2 w-6 h-6 bg-bg-tertiary hover:bg-bg-quaternary rounded-full flex items-center justify-center transition-colors group"
        >
          <X className="w-3 h-3 text-text-tertiary group-hover:text-text-primary" />
        </button>

        {/* Content */}
        <div className="space-y-3">
          {/* Logo and Title */}
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-lg bg-brand-primary/10 flex items-center justify-center flex-shrink-0">
              <img 
                src="https://media.cara.id/images/logo-cara-white.png" 
                alt="Cara Logo" 
                className="w-5 h-5 object-contain"
              />
            </div>
            <div>
              <h3 className="text-sm font-medium text-text-primary">
                Masuk ke Cara
              </h3>
              <p className="text-xs text-text-tertiary">
                Akses fitur lengkap
              </p>
            </div>
          </div>

          {/* Sign In Button */}
          <button
            onClick={handleSignInClick}
            className="w-full flex items-center justify-center gap-2 bg-brand-primary hover:bg-brand-primary/90 text-white font-medium py-2.5 px-4 rounded-lg transition-colors group"
          >
            <LogIn className="w-4 h-4 group-hover:scale-105 transition-transform" />
            <span className="text-sm">Masuk Sekarang</span>
          </button>

          {/* Small description */}
          <p className="text-xs text-text-quaternary text-center">
            Simpan hasil pencarian dan akses riwayat
          </p>
        </div>
      </div>
    </div>
  )
}

AuthPrompt.propTypes = {
  onAuthModalOpen: PropTypes.func.isRequired
}

export default AuthPrompt